import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import Experience from './Experience.js'

export default class Camera {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.setInstance()
        this.setControls()
    }

    // Pull camera back on narrow viewports so the particle sphere stays fully in frame.
    // Sphere radius ≈ 0.3 world units; FOV is vertical (Three.js convention).
    _calcZ() {
        const aspect = this.sizes.width / this.sizes.height
        if (aspect >= 1) return 1.0
        const tanHalf = Math.tan(17.5 * Math.PI / 180)  // FOV 35° → half-angle
        const z = (0.3 * 1.2) / (tanHalf * aspect)       // sphere radius + 20% padding
        return Math.min(2.5, z)
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(
            35,
            this.sizes.width / this.sizes.height,
            0.1,
            100
        )
        this.instance.position.set(0, 0, this._calcZ())
        this.scene.add(this.instance)
    }

    setControls() {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        this.controls.enabled = false
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.position.z = this._calcZ()
        this.instance.updateProjectionMatrix()

        // Re-sync background scale now that camera z may have changed
        this.experience.world?.background?.resize()
    }

    update() {
        this.controls.update()
    }
}
